import createReducer from 'legacy/src/shared/util/createReducer';
import {
  assignAssessmentRoutine,
  RESET_ASSIGNMENT_STATE,
  ASSIGNMENT_GROUP_CHANGED,
  ASSIGNABLE_GROUP_MEMBERS_CHANGED,
} from './actions';

const initialState = {
  assignments: null,
  submitting: false,
};

const reducer = createReducer(initialState, {
  [RESET_ASSIGNMENT_STATE]: () => initialState,
  [ASSIGNMENT_GROUP_CHANGED]: (
    state,
    { assessmentGroup, assignableGroupMembers },
  ) => {
    if (!assessmentGroup && state.assessmentGroup) {
      return {
        ...state,
        assessmentGroup: null,
        assignableGroupMembers: null,
      };
    }

    if (
      !state.assessmentGroup ||
      assessmentGroup.id !== state.assessmentGroup.id
    ) {
      return {
        ...state,
        assessmentGroup,
        assignableGroupMembers:
          assignableGroupMembers || state.assignableGroupMembers,
      };
    }
    return state;
  },
  [ASSIGNABLE_GROUP_MEMBERS_CHANGED]: (state, { assignableGroupMembers }) => ({
    ...state,
    assignableGroupMembers,
  }),
  [assignAssessmentRoutine.request]: (state) => ({
    ...state,
    submitting: true,
  }),
  [assignAssessmentRoutine.success]: (state, { payload }) => ({
    ...state,
    assignments: payload,
    submitting: false,
  }),
  [assignAssessmentRoutine.failure]: (state) => ({
    ...state,
    submitting: false,
  }),
});

export default reducer;
